<template>
  <div>
    <Card v-show="!formOpened" class="widget-height-md ivu-card-custom" shadow>
      <div slot="title" class="with-icon">
        <h4>Customized Forms Answers</h4>
        <Icon type="ios-arrow-back" color="white" size="24" title="Back to Leads Processed"
              @click.native="goBackToLeadsProcessed"/>
      </div>
      <div class="widget-data full-height">
        <Table :columns="dataColumns" :data="items" class="full-height show-borders initial-height"
               stripe border shadow></Table>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
    </Card>
    <Card v-show="formOpened" class="widget-height-md ivu-card-custom" shadow>
      <div slot="title" class="with-icon">
        <h4>{{formName}}</h4>
        <Icon type="ios-arrow-back" color="white" size="24" title="Back to Main Form" @click.native="goBack"/>
      </div>
      <div class="widget-data full-height">
        <Table border :data="answerList" :columns="formDataColumns" :key=""
               class="full-height show-borders initial-height" stripe border shadow>
        </Table>
        <Page v-show="showPager" :total="dataCount" :page-size="pageSize"
              show-total show-sizer :page-size-opts="pageSizer" transfer
              @on-change="changeSelectedPage" @on-page-size-change="changePageSize">
        </Page>
        <Spin size="large" fix v-if="spinShow"></Spin>
      </div>
    </Card>
  </div>
</template>

<script>
  import {getSurveyProcessed} from '../../services/SurveyForms.service'
  import {bus} from '../../main'

  export default {
    data() {
      return {
        companyName: null,
        eventName: null,
        index: 0,
        formOpened: false,
        formName: null,
        status: true,
        showFormModal: false,
        typeList: [
          {type: 'buttonGroup', inputType: 'buttons', title: 'Button Group'},
          {type: 'text', inputType: 'email', title: 'Email'},
          {type: 'text', inputType: 'phoneNumber', title: 'Phone'},
          {type: 'text', inputType: 'text', title: 'String'},
          {type: 'text', inputType: 'date', title: 'Date'},
          {type: 'textArea', inputType: 'textArea', title: 'Text Area'},
          {type: 'checkbox', inputType: 'multiChoice', title: 'multiple Choice'},
          {type: 'leadRating', inputType: 'radio', title: 'Lead Rating'},
          {type: 'radioList', inputType: 'singleChoice', title: 'Single Choice'},
          {type: 'select', inputType: 'country', title: 'Country'},
        ],
        indeterminate: null,
        checkAll: false,
        ruleValidate: {},
        spinShow: true,
        confirmDelete: false,
        confirmDeleteMessage: '',
        currentDeleteIndex: null,
        dataColumns: [
          {
            title: 'Form Name',
            key: 'formName',
            sortable: true,
            align: 'left',
            className: 'paddingIndent',
          },
          {
            title: 'Quantity',
            key: 'quantity',
            sortable: false,
            align: 'left',
            minWidth: 80,
            width: 80,
            className: 'paddingIndent',
          },
          {
            title: 'Action',
            key: 'action',
            align: 'left',
            minWidth: 150,
            maxWidth: 150,
            className: 'paddingIndent',
            render: (h, params) => {
              if (params.row.quantity > 0) {
                return h('div', [
                  h('Icon', {
                    props: {
                      type: 'ios-eye-outline',
                      size: '24'
                    },
                    on: {
                      click: () => {
                        this.setFormValue(params.row);
                      }
                    }
                  })
                ]);
              }
            }
          }
        ],
        items: [{
          surveyFormId: null,
          formId: null,
          leadId: null,
          formName: null,
          firstName: null,
          lastName: null,
          company: null,
          email: null,
          questions: [{
            questionId: 0,
            formId: null,
            title: '',
            type: '',
            inputType: '',
            fieldCode: '',
            order: 0,
            visible: false,
            answer: [{
              questionId: 0,
              answerType: '',
              answerValue: '',
              fieldCode: ''
            }],
            choices: [{
              actionOnSync: null,
              choiceId: 0,
              label: '',
              order: 0,
              questionId: 0
            }]
          }]
        }],
        dataCount: 0,
        pageSizer: [25, 50, 100],
        pageSize: 25,
        historyData: [],
        showPager: false,
        formDataColumns: [],
        answerList: [],
        questionnaireProcessedForm: [{
          formId: null,
          formName: null,
          quantity: 0,
          questions: [{
            index: null,
            questionId: null,
            formId: null,
            title: null,
            type: null,
            order: null,
            status: null,
            visible: null,
            allowOther: null,
            choices: []
          }],
          answers: [{
            answerValue: null,
            dataType: null,
            others: null,
            questionId: null,
          }]
        }],
      }
    },
    methods: {
      getSurveyFormsData() {
        const vm = this;
        vm.items = [];
        vm.spinShow = true;
        vm.showPager = false;

        let companies = JSON.parse(localStorage.getItem('companies'));
        if (companies) {
          let company = companies.filter(a => a.companyId == localStorage.getItem('selected_company'));
          if (company.length > 0) {

            let eventsList = JSON.parse(localStorage.getItem('events'));
            if (eventsList) {

              let event = eventsList.filter(a => a.eventId == localStorage.getItem('selected_event'));
              if (event.length > 0) {

                vm.companyName = company[0].companyName;
                vm.eventName = event[0].eventName;
                let companyId = company[0].companyId;
                let eventId = event[0].eventId;

                getSurveyProcessed(false, companyId, eventId).then(response => {
                  vm.items = response.data;
                  vm.items.sort((a, b) => (a.formId < b.formId) ? 1 : ((b.formId < a.formId) ? -1 : 0));
                  vm.spinShow = false;
                  vm.showPager = true;
                }, []);
              } else {
                vm.items = [];
                vm.showPager = false;
                vm.spinShow = false;
              }
            } else {
              vm.showPager = false;
              vm.spinShow = false;
            }
          } else {
            vm.showPager = false;
            vm.spinShow = false;
          }
        } else {
          vm.showPager = false;
          vm.spinShow = false;
        }
      },
      showSpin() {
        const vm = this;
        vm.spinShow = true;
      },
      setFormValue(params) {
        const vm = this;
        vm.handleReset();
        vm.formOpened = true;
        vm.formDataColumns = [];
        vm.answerList = [];
        vm.questionnaireProcessedForm = [];
        let data = Object.assign({}, params);
        delete data['_index'];
        delete data['_rowKey'];

        let newData = {};
        newData.formId = data['formId'];
        vm.formName = data['formName'];
        newData.formName = data['formName'];
        newData.quantity = data['quantity'];
        newData.questions = [];
        newData.answers = [{}];

        if (params.surveys) {

          //build columns headers
          params.surveys.map((survey, ix) => {
            if (ix == 0) {
              if (survey.questions) {
                survey.questions.map(q => {
                  let colKey = q.questionId;
                  let col = {
                    title: q.title,
                    key: colKey,
                    sortable: false,
                    align: 'left',
                    className: 'paddingIndent',
                  };
                  newData.questions.push(q);
                  vm.formDataColumns.push(col);
                });
              }
            }
            if (survey.answers) {
              let row = {};
              survey.questions.map(q => {
                let colKey = q.questionId;
                let choices = q.choices;
                let surveyAns = survey.answers;
                for (var answer in surveyAns) {
                  if (surveyAns[answer].dataType === 'number') {
                    var choiceString = choices.filter(a => a.choiceId === surveyAns[answer].answerValue)[0].label;
                    newData.answers.push(choiceString);
                    row[colKey] = choiceString;
                  }
                  if (surveyAns[answer].dataType === 'array') {
                    let ansStr = '';
                    let ansArr = JSON.parse(surveyAns[answer].answerValue);
                    for (var ans in ansArr) {
                      var choiceString = choices.filter(a => a.choiceId === ansArr[ans])[0].label;
                      ansStr += choiceString;
                    }
                    newData.answers.push(choiceString);
                    row[colKey] = choiceString;
                  }
                  if (surveyAns[answer].dataType === 'string') {
                    newData.answers.push(surveyAns[answer].answerValue);
                    row[colKey] = surveyAns[answer].answerValue;
                  }
                }
                vm.answerList.push(row);
                vm.questionnaireProcessedForm.push(newData);
              });
            }


            // if (survey.questions) {
            //   let row = {};
            //   survey.questions.map(q => {
            //     let colKey = q.questionId;
            //     let ansText = '';
            //     let choices = q.choices;
            //     let hasChoices = choices !== null ? (choices.length > 0) : false;
            //
            //     //add answer
            //     if (survey.answers) {
            //       let answerObj = survey.answers.filter(a => a.questionId === q.questionId);
            //       if (answerObj.length > 0) {
            //         let ans = survey.answers.filter(a => a.questionId === q.questionId)[0];
            //         row[colKey] = ans.answerValue;
            //
            //         if (hasChoices) {
            //           let validArray = this.isJsonString(ans.answerValue);
            //           if (validArray) {
            //             let arr = JSON.parse(ans.answerValue);
            //             for (let i = 0; i < arr.length; i++) {
            //               choices
            //                 .filter(c => c.choiceId === arr[i].toString())
            //                 .map(c => {
            //                   ansText += c.label + ',';
            //                 });
            //             }
            //             row[colKey] = ansText.replace(/,\s*$/, '').replace(/,/g, ' - ');
            //           }
            //         }
            //         newData.answers.push(ans);
            //       }
            //     }
            //   });
            //   vm.answerList.push(row);
            //   vm.questionnaireProcessedForm.push(newData);
            // }
          });
          vm.historyData = vm.answerList;
          vm.spinShow = false;
          vm.dataCount = vm.answerList.length;

          if (vm.historyData.length < vm.pageSize) {
            vm.answerList = vm.historyData;
          } else {
            vm.answerList = vm.historyData.slice(0, vm.pageSize);
          }
        }
      },
      changePageSize(size) {
        const vm = this;
        vm.pageSize = size;
        vm.changeSelectedPage(1);
      },
      changeSelectedPage(index) {
        const vm = this;
        let _start = (index - 1) * vm.pageSize;
        let _end = index * vm.pageSize;
        vm.answerList = vm.historyData.slice(_start, _end);
      },
      handleReset() {
        const vm = this;
        Object.keys(vm.questionnaireProcessedForm).forEach(function (key, i) {
          vm.questionnaireProcessedForm[key] = '';
        });
      },
      goBack() {
        const vm = this;
        vm.formOpened = false;
        vm.getSurveyFormsData()
      },
      goBackToLeadsProcessed() {
        bus.$emit('getActiveLink', 'LeadsProcessed');
      },
      isJsonString(str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      },
      setSurveyProcessed(survey) {
        const vm = this;
        vm.handleReset();
        vm.formOpened = true;
        vm.formDataColumns = [];
        vm.answerList = [];
        vm.questionnaireProcessedForm = [];
        let data = Object.assign({}, survey);
        delete data['_index'];
        delete data['_rowKey'];
        let newData = {};
        newData.formId = data['formId'];
        vm.formName = data['formName'];
        newData.formName = data['formName'];
        newData.quantity = data['quantity'];
        newData.questions = [];
        newData.answers = [{}];
        if (survey) {
          if (survey.questions) {
            survey.questions.map(q => {
              let colKey = q.questionId;
              let col = {
                title: q.title,
                key: colKey,
                sortable: false,
                align: 'left',
                className: 'paddingIndent',
              };
              newData.questions.push(q);
              vm.formDataColumns.push(col);
            });
            let row = {};
            survey.questions.map(q => {
              let colKey = q.questionId;
              let ansText = '';
              let choices = q.choices;
              let hasChoices = choices !== null ? (choices.length > 0) : false;

              //add answer
              if (survey.answers) {
                let answerObj = survey.answers.filter(a => a.questionId === q.questionId);
                if (answerObj.length > 0) {
                  let ans = survey.answers.filter(a => a.questionId === q.questionId)[0];
                  row[colKey] = ans.answerValue;

                  if (hasChoices) {
                    let validArray = this.isJsonString(ans.answerValue);
                    if (validArray) {
                      let arr = JSON.parse(ans.answerValue);
                      for (let i = 0; i < arr.length; i++) {
                        choices
                          .filter(c => c.choiceId === arr[i].toString())
                          .map(c => {
                            ansText += c.label + ',';
                          });
                      }
                      row[colKey] = ansText.replace(/,\s*$/, '').replace(/,/g, ' - ');
                    }
                  }
                  newData.answers.push(ans);
                }
              }
            });
            vm.answerList.push(row);
            vm.questionnaireProcessedForm.push(newData);
          }
        }
        vm.historyData = vm.answerList;
        vm.spinShow = false;
        vm.dataCount = vm.answerList.length;
        if (vm.historyData.length < vm.pageSize) {
          vm.answerList = vm.historyData;
        } else {
          vm.answerList = vm.historyData.slice(0, vm.pageSize);
        }
      }
    },
    created() {
      this.getSurveyFormsData();
    },
    mounted() {
      this.getSurveyFormsData();
      const vm = this;
      bus.$on('getQuestionnaireProcessed', () => {
        vm.getSurveyFormsData();
      });
      bus.$on('LoadSurveys', (survey) => {
        vm.setSurveyProcessed(survey);
      });
    }
  }
</script>
<style scoped>

  .ivu-table td {
    height: 50px;
  }

  .ivu-card-custom {
    overflow: auto;
    height: auto;
  }


  .ivu-table table tbody tr td {
    vertical-align: top;
  }

  .ivu-table-wrapper:not(.show-borders) .ivu-table table tbody tr:last-of-type td {
    vertical-align: top;
    padding-top: 0;
  }

  .ivu-table .table-cell-custom {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ivu-table-cell .ivu-poptip,
  .ivu-table-cell .ivu-table-sort {
    position: absolute;
    right: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/e_QuestionnaireProcessed/_questionnaireProcessed.vue